import * as i18next from 'i18next'
import { t } from 'i18next'
import moment from 'moment'
import React from 'react'
import { any, async, fromJSX, Fun, Link, loadingAsyncState, StandardLocalWidget } from 'widgets-for-react'
import { getClassName } from '../../cms/blocks/utils.gen'
import { LinkGridBlockStyle } from '../../cms/blocks/widgets/linkGridBlock.gen'
import { parseMediaUrl } from '../../drupal/drupal_to_cms.mod'
import { getDrupalLanguage, PaginatedItem } from '../../drupal/types_and_parser/extra_types.mod'
import { ParsedNodeStory } from '../../drupal/types_and_parser/types'
import { linkGridBlockClasses } from '../blocks/style.mod'
import { PageHeader } from '../templates/pageHeader'
import { Pagination } from '../templates/pagination.mod'
import { defaultLanguage, getLangFromUrl, updateUrlLang } from '../utils/history.mod'
import { getOverview } from './api'
import { StoryOverviewState } from './state'

export const storyOverviewWidget =
  (lang: string): StandardLocalWidget<StoryOverviewState> =>
  (state) =>
    any([
      async(state.storyPage).map(
        (updater) =>
          (state): StoryOverviewState => ({ ...state, storyPage: updater(state.storyPage) })
      ),
      async(state.get_stories).map(
        (updater) =>
          (state): StoryOverviewState => ({ ...state, get_stories: updater(state.get_stories) })
      ),
      fromJSX((setState) => {
        lang = lang || defaultLanguage
        return (
          <>
            {state.storyPage.kind == 'loaded' && PageHeader([], [], [], state.storyPage.value.node)}
            {state.get_stories.kind == 'loaded' ? (
              storyOverview(
                state.get_stories.value,
                (filter) =>
                  setState((s1) => ({
                    ...s1,
                    get_stories: loadingAsyncState(() =>
                      getOverview<ParsedNodeStory>('stories-overview', lang, state.overview_page)
                    )
                  })),
                (page) => {
                  window.history.pushState({}, '', `/${lang}/stories/${page}`)
                  setState(
                    (state): StoryOverviewState => ({
                      ...state,
                      overview_page: page,
                      get_stories: loadingAsyncState(() => getOverview<ParsedNodeStory>('stories-overview', lang, page))
                    })
                  )
                },
                state.overview_page,
                lang
              )
            ) : (
              <div className="loader">
                <div className="loader__inner"></div>
              </div>
            )}
          </>
        )
      })
    ])

const options: { style?: LinkGridBlockStyle } = {
  style: linkGridBlockClasses
}

const storyOverview = (
  page: PaginatedItem<ParsedNodeStory>,
  setNewsTypeFilter: Fun<string, void>,
  setPage: (page: number) => void,
  current_page: number,
  lang: string
) => {
  return (
    <>
      <main id="a11y-main" className="main main--stories-overview">
        <div className="main__inner">
          <article className="page">
            <div className="page__inner">
              <div className="page__content">
                <section className="block block--linkgrid block--variant-square" key={'news-overview'}>
                  <div className={getClassName(options, 'inner_classname', 'py-5')}>
                    <div className={getClassName(options, 'content_classname', '')}>
                      {!page.items || page.items.count() == 0 ? (
                        <p>{t('Stories:no_results')}</p>
                      ) : (
                        <ul className={getClassName(options, 'list_classname', 'row list-unstyled mb-0')}>
                          {page.items
                            .map((item: ParsedNodeStory) => {
                              return storyItem(item, lang)
                            })
                            .toArray()}
                        </ul>
                      )}
                      {page.pager && <Pagination pager={page.pager} setPage={setPage} />}
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </article>
        </div>
      </main>
    </>
  )
}

export type PageTeaser = {
  title: string
  field_introduction_image: string
  field_introduction: string
  field_category?: string
  creation_date: string
  view_node: string
}

export const storyItem = (story_item: PageTeaser | ParsedNodeStory, lang: string) => {
  const isPageTeaser = (entity): entity is PageTeaser => (entity as PageTeaser).view_node !== undefined

  const link = isPageTeaser(story_item)
    ? story_item.view_node
    : story_item.language_links.get(getDrupalLanguage(getLangFromUrl()))
  const title = isPageTeaser(story_item) ? story_item.title : story_item.label
  let image = ''
  let alt = ''
  const creationDate: moment.Moment = isPageTeaser(story_item)
    ? moment(story_item.creation_date).locale(lang)
    : story_item.created

  if (isPageTeaser(story_item)) {
    image = story_item.field_introduction_image
  } else if (!isPageTeaser(story_item)) {
    if (story_item.field_introduction_image && story_item.field_introduction_image.thumbnail.image) {
      image = story_item.field_introduction_image.thumbnail.image.style_urls.grid
      alt = story_item.field_introduction_image.thumbnail.alt
    }
  }

  return (
    <li className="grid__item">
      <article className="grid__article">
        <Link to={updateUrlLang(link, getLangFromUrl())} className="grid__link">
          <div className="grid__content">
            <header className="grid__header">
              <time className="grid__label block__label label--m" dateTime={creationDate.format()}>
                {creationDate.locale(lang).format('D MMMM YYYY')}
              </time>
              <h3 className={getClassName(options, 'grid_title_classname', 'mb-2')}>{title}</h3>
            </header>
            <span className={getClassName(options, 'grid_fauxlink_classname', 'btn btn-link pl-0')}>
              {i18next.t('Stories:read_more')}
            </span>
          </div>
          <div className={`grid__visual container fit-object${image ? '' : ' grid__placeholder'}`}>
            {image && <img src={parseMediaUrl(image)} alt={alt} className="grid__image lazyautosizes lazyloaded" />}
          </div>
        </Link>
      </article>
    </li>
  )
}
